
import { FC, useCallback, useContext, useEffect, useState } from "react";
// @ts-ignore
import TawkMessengerReact from "@tawk.to/tawk-messenger-react";

import { AuthContext } from "src/context/authContext";
import { shutDownAndEndChat, startChat } from "src/helpers/tawkto";
import {USER_TYPES} from "../../constants";


const TawkToMessengerComp: FC = (): JSX.Element => {
  const [isTawkMounted, setTawkMounting] = useState<boolean>(false);
  const { userData } = useContext(AuthContext);

  /**
   * Handling widget show & hide in tawk.to package while user auth changes
   */
  const onLoadTawk = useCallback(() => {
    if (userData) {
      if (!USER_TYPES.MANUFACTURER.includes(userData.ref_type)) startChat(userData);
      else shutDownAndEndChat();
    } else {
      shutDownAndEndChat();
    }
  }, [userData]);

  useEffect(() => {
    onLoadTawk();
  }, [onLoadTawk]);

  const eventListenerOnFocus = useCallback(() => {
    if (document.visibilityState === "visible") {
      if (userData === null && isTawkMounted) {
        setTawkMounting(false);
        shutDownAndEndChat();
      } else if (userData !== null && !USER_TYPES.MANUFACTURER.includes(userData.ref_type) && !isTawkMounted) {
        setTawkMounting(true);
        startChat(userData);
      } else if (userData !== null && isTawkMounted) {
        if (!USER_TYPES.MANUFACTURER.includes(userData.ref_type)) {
          setTawkMounting(false);
          shutDownAndEndChat();
        }
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTawkMounted, onLoadTawk, userData]);

  useEffect(() => {
    document.addEventListener("visibilitychange", eventListenerOnFocus);
    return () => document.removeEventListener("visibilitychange", eventListenerOnFocus);
  }, [eventListenerOnFocus]);

  return (
    <TawkMessengerReact
      propertyId="65df3bd19131ed19d972e37b"
      widgetId="1hno03bn3"
    />
  );
};

export default TawkToMessengerComp;